import { blockedPhoneNumber } from "core/UrlEndpoints";
import CrudService from "./CrudService";

class BlockedPhoneNumberService extends CrudService {
  constructor() {
    super(blockedPhoneNumber);
  }
}

export default new BlockedPhoneNumberService();
